var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("标签名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("标签名称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.getClassificationTable
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))])], 1), _c("a-form-item", [_vm.isAuth("customer.insuranceLabelStore") ? _c("a-button", {
    staticClass: "select-bottom",
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("新增标签")))]) : _vm._e()], 1), _c("a-form-item", [_vm.isAuth("customer.insuranceLabelDelete") ? _c("a-button", {
    staticClass: "select-bottom",
    attrs: {
      type: "danger"
    },
    on: {
      click: _vm.handleDel
    }
  }, [_vm._v(_vm._s(_vm.$t("批量删除标签")))]) : _vm._e()], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "row-selection": _vm.rowSelection,
      "expanded-row-keys": _vm.expandedRowKeys,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      "update:expandedRowKeys": function ($event) {
        _vm.expandedRowKeys = $event;
      },
      "update:expanded-row-keys": function ($event) {
        _vm.expandedRowKeys = $event;
      },
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record);
            }
          }
        })];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_vm.isAuth("customer.insuranceLabelEdit") && record.isEdit == 1 ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.isAuth("customer.insuranceLabelDelete") && record.isEdit == 1 ? _c("a-button", {
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleDelete(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.categoryShow ? _c("label-model", {
    ref: "categoryForm",
    on: {
      cancel: function ($event) {
        _vm.categoryShow = false;
      },
      ok: _vm.getTableFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };